/* eslint-disable class-methods-use-this */
/* eslint-disable react/destructuring-assignment */
import { makeVar } from '@apollo/client'
import { Component } from 'react'

import ModalRenderer, { ModalRendererProps } from './ModalRenderer'

export interface ModalProps extends ModalRendererProps {
  modalId?: string
}

export default class Modal extends Component<ModalProps> {
  static openedStack: string[] = []

  static createModalHandlerReactiveVar = () => {
    const reactiveVar = makeVar<boolean>(false)

    return {
      var: reactiveVar,
      open: () => reactiveVar(true),
      close: () => reactiveVar(false),
      toggle: () => reactiveVar(!reactiveVar()),
    }
  }

  private modalId: string

  constructor(props) {
    super(props)
    this.modalId = this.props.modalId || `${Math.random()}-modal`
  }

  componentDidMount() {
    if (this.props.opened) this.safeAddToStack()
  }

  componentDidUpdate(prevProps: ModalProps) {
    if (!prevProps.opened && this.props.opened) {
      this.safeAddToStack()
    }

    if (prevProps.opened && !this.props.opened) {
      this.safeRemoveFromStack()
    }
  }

  componentWillUnmount() {
    if (this.props.opened) this.safeRemoveFromStack()
  }

  get lastOpened() {
    return Modal.openedStack[Modal.openedStack.length - 1]
  }

  onEscapePress = () => {
    if (this.lastOpened === this.modalId) this.props.onEscapePress?.()
  }

  safeAddToStack = () => {
    if (!Modal.openedStack.includes(this.modalId)) Modal.openedStack.push(this.modalId)
  }

  safeRemoveFromStack = () => {
    if (this.lastOpened === this.modalId) Modal.openedStack.pop()
  }

  render() {
    return <ModalRenderer {...this.props} onEscapePress={this.onEscapePress} />
  }
}
